import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import InvestorAccountTable from './InvestorAccountTable';
import InvestorAccountDetails from './InvestorAccountDetails';
import { ListContainer } from 'components';

const InvestorsAccounts = () => {
    return (
        <ListContainer>
            <Routes>
                <Route path="details/:userId" element={<InvestorAccountDetails />} />
                <Route index element={<InvestorAccountTable />} />
                <Route path="*" element={<Navigate to="/investor-accounts" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default InvestorsAccounts;
